import { Gap, Mode } from './enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.VERTICAL]: css.vertical,
  [Mode.HORIZONTAL]: css.horizontal,
};

export const gapPresets: Record<Gap, Maybe<string>> = {
  [Gap.SMALL]: css.small,
  [Gap.MEDIUM]: css.medium,
  [Gap.NONE]: undefined,
};
